/**
 * Sentinel returned by the API for the built-in system user; not a valid Gravatar MD5.
 * The webapp renders the Note Plan mark instead of Gravatar.
 */
export const SYSTEM_GRAVATAR_HASH = 'system';

/** Gravatar image URL; `d=mp` is a generic silhouette when the user has no Gravatar. */
export function gravatarAvatarUrl(
  gravatarHash: string,
  pixelSize: number,
): string {
  const params = new URLSearchParams({
    s: String(Math.round(pixelSize)),
    d: 'mp',
  });
  return `https://www.gravatar.com/avatar/${gravatarHash}?${params.toString()}`;
}
